
import React from 'react';
import { useEffect, useState } from 'react';

import { withStyles } from 'tss-react/mui';
import { Container, Paper, Button, TextField, Snackbar, Modal, Typography, Rating, Alert, } from '@mui/material';

import { userService } from '../services/user_functions';

  const useStyles = (theme, props) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    text: {
      marginTop: theme.spacing(0.8),
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 100,
      color: '#fff',
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    rating: {
        margin: theme.spacing(1)
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    textfield: {
    },
    
  });


const FeedBack = ({open = true, close=()=>{}, openAutomatic=()=>{}, openAutomaticTime=3000, classes}) => {

    const [state, setter] = useState({
        feedbackSent: false,
        openSnack: false,
        openErrorSnack: false,
        errorSnackMessage: 'Tivemos um problema. Tente novamente mais tarde'
    })
    const [isOpen, setIsOpen] = useState(open) // setIsOpen não deve ser chamado manualmente
    const [ratingValue, setRatingValue] = useState(3)
    const [message, setMessage] = useState("")

    useEffect(()=>{
        setIsOpen(open)
    },[open])

    useTimerPopup(openAutomatic, openAutomaticTime)

    const setState = (value) => {
        setter(old => ({...old, ...value}))
    }

    const handleClose = () =>{
        if (isOpen){
            close()
            // setState({openSnack: false, openErrorSnack:false})
        }
    }

    const handleCloseSnack = (reason) =>{
      // console.log(reason)
      if (reason !== 'clickaway'){
        setState({openSnack: false, openErrorSnack:false})
      }}

    const handleClick = () =>{
        sendFeedBack()
    }

    const sendFeedBack = ()=> {
      // console.log(ratingValue? ratingValue:0)
      // console.log(message)
      if (!ratingValue){
          setState({openErrorSnack:true, errorSnackMessage: 'Selecione uma nota de 1 a 5'})
          return
      }
      userService.send_feedback(ratingValue? ratingValue:1, message)
      .then( r =>{
          setState({
          feedbackSent:true,
          openSnack: true
          })
          close()
      })
      .catch(e => {
          setState({openErrorSnack:true, errorSnackMessage: 'Tivemos um problema. Tente novamente mais tarde'})
      })
    }

        return(
        <Container component="main" maxWidth="xs" className={classes.paper}>
            <Modal
            open={isOpen}
            onClose={handleClose}
            className={classes.modal}
            >
            <Paper elevation={12} >
                <Typography  align='right' style={{margin: '20px', marginBottom: '0px'}}>
                    <button
                    onClick={handleClose}
                    style={{ background: 'none', border: 'none', }}
                    >X</button>
                </Typography>
                <Container className={classes.column}>
                <Typography align='center' variant='h4'>Sua avaliação</Typography>
                <Typography align='center' >Como foi sua experiência?</Typography>
                <Rating
                className={classes.rating}
                name='rating'
                size='large'
                value={ratingValue}
                disabled={state.feedbackSent}
                onChange={(event, newValue) => {setRatingValue(newValue)}}
                />
                <TextField
                name='message'
                multiline
                minRows={4}
                maxRows={7}
                variant='outlined'
                placeholder="Escreva aqui seu comentário"
                disabled={state.feedbackSent}
                onChange={(e) => { if (e.target.value.length<=200) {setMessage(e.target.value)}}}
                value={message}
                slotProps={{ htmlInput: { style: { textAlign: 'left', verticalAlign: 'top' }}}}
                />
                  <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={handleClick} disabled={state.feedbackSent} >Enviar Avaliação</Button>
                  <Button fullWidth variant="outlined" color="primary" style={{marginBottom:'20px'}} onClick={handleClose} disabled={state.feedbackSent} >Agora não</Button>

              </Container>
            </Paper>
            </Modal>
            <Snackbar className={classes.Backdrop} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={state.openSnack} autoHideDuration={3000} onClose={handleCloseSnack}>
              <Alert variant="filled" severity='success'>Avaliação enviada com sucesso!</Alert>
            </Snackbar>
            <Snackbar className={classes.Backdrop} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={state.openErrorSnack} autoHideDuration={3000} onClose={(r)=>handleCloseSnack(r)}>
              <Alert variant="filled" severity='error'>{state.errorSnackMessage}</Alert>
            </Snackbar>
        </Container>
        )

}


export default withStyles(FeedBack, useStyles);



const useTimerPopup = (onOpenPopup, delay = 30000) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onOpenPopup();
    }, delay);
    return () => clearTimeout(timer);
  }, [onOpenPopup, delay]);
};

